import SFetch from '@app/utils/sfetch'
import { SfLog } from '@app/adapters/logger'

export async function updateLedgerCheckListFilter(
  ledgerCheckListId: string,
  filter: string
): Promise<void> {
  const url =
    window.Silverfin.Routes.update_ledger_check_list_filter_users_path(
      window.Silverfin.currentFirmId,
      { ledger_check_list_id: ledgerCheckListId, filter }
    )

  try {
    await SFetch.jsonWithAlert(url, { method: 'POST' })
  } catch (e) {
    SfLog.error('Cannot update ledger check list filter', {
      error: e,
    })
  }
}
